import { createSlice } from '@reduxjs/toolkit';

interface SideBarState {
  isMenuOpened: boolean;
  isCartDrawerOpened: boolean;
}

const initialState = {
  isMenuOpened: false,
  isCartDrawerOpened: false,
} as SideBarState;

const sideBarSlice = createSlice({
  name: 'sideBar',
  initialState: initialState,
  reducers: {
    openMenu: (state) => {
      state.isMenuOpened = true;
    },
    closeMenu: (state) => {
      state.isMenuOpened = false;
    },
    openCartDrawer: (state) => {
      state.isCartDrawerOpened = true;
    },
    closeCartDrawer: (state) => {
      state.isCartDrawerOpened = false;
    },
  },
});

export const { openMenu, closeMenu, openCartDrawer, closeCartDrawer } = sideBarSlice.actions;
export default sideBarSlice.reducer;
